import React, {useEffect, useState} from 'react';

import {getContractTypes} from '../DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";

import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownUserContractTypes = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getContractTypes(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownUserContractTypes;

DropdownUserContractTypes.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownUserContractTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};